import React from "react";
import { Phone } from "lucide-react";

export default function FloatingContactButtons() {
  const phoneNumber = "+919915417572";
  const whatsappNumber = "919915417572";
  const whatsappMessage = encodeURIComponent("Hello Shiv Auto Components, I would like to inquire about your manufacturing services.");

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3.5 items-end select-none">
      {/* WhatsApp Floating Button (Rings First) */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        className="group relative flex items-center gap-2.5"
      >
        {/* Tooltip Badge */}
        <span className="hidden sm:block opacity-0 group-hover:opacity-100 transition-all duration-200 translate-x-1 group-hover:translate-x-0 text-xs font-semibold bg-[#0F2B46] text-white px-3 py-1.5 rounded-xl shadow-md border border-white/10 whitespace-nowrap">
          Chat on WhatsApp
        </span>

        {/* Outer Expanding Ring — Pulses on 1st beat */}
        <div className="relative w-12 h-12 sm:w-13 sm:h-13">
          <span
            className="absolute inset-0 rounded-full border-2 border-[#25D366] animate-ping opacity-50 pointer-events-none"
            style={{ animationDuration: "2.4s", animationDelay: "0s" }}
          />
          <div className="w-full h-full rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200 border border-white/40 relative z-10">
            <svg
              className="w-6 h-6 fill-current"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.572-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.99c-.002 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c-.001 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413" />
            </svg>
          </div>
        </div>
      </a>

      {/* Phone Call Floating Button (Rings Second - Staggered) */}
      <a
        href={`tel:${phoneNumber}`}
        aria-label="Call Us Now"
        className="group relative flex items-center gap-2.5"
      >
        {/* Tooltip Badge */}
        <span className="hidden sm:block opacity-0 group-hover:opacity-100 transition-all duration-200 translate-x-1 group-hover:translate-x-0 text-xs font-semibold bg-[#0F2B46] text-white px-3 py-1.5 rounded-xl shadow-md border border-white/10 whitespace-nowrap">
          Call +91 9915417572
        </span>

        {/* Outer Expanding Ring — Pulses on 2nd beat (Staggered by 1.2s) */}
        <div className="relative w-12 h-12 sm:w-13 sm:h-13">
          <span
            className="absolute inset-0 rounded-full border-2 border-[#B91C1C] animate-ping opacity-50 pointer-events-none"
            style={{ animationDuration: "2.4s", animationDelay: "1.2s" }}
          />
          <div className="w-full h-full rounded-full bg-[#B91C1C] text-white flex items-center justify-center shadow-lg hover:shadow-xl hover:scale-105 active:scale-95 transition-all duration-200 border border-white/40 relative z-10">
            <Phone className="w-5.5 h-5.5" />
          </div>
        </div>
      </a>
    </div>
  );
}
